import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/customsDeclaration/findByPage",
    method: "post",
    data
  });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function SaveCustomsDeclaration(data) {
  return request({
    url: "/base/customsDeclaration/saveCustomsDeclaration",
    method: "post",
    data
  });
}
/**
 * 删除记录
 * @param {*} data
 */
export function DeleteDataById(data) {
  return request({
    url: "/base/customsDeclaration/deleteCustomsDeclarationByIds",
    method: "post",
    data
  });
}
/**
 * 根据id获取单条信息
 * @param {*} data
 */
export function FetchFindById(data) {
  return request({
    url: "/base/customsDeclaration/findCustomsDeclarationById",
    method: "post",
    data
  });
}

/**
 * 查询注册审核数据
 * @param {*} data
 */
export function FindReviewByPage(data) {
  return request({
    url: "/base/comparyReview/findByPage",
    method: "post",
    data
  });
}

/**
 * 企业注册审核
 * @param {*} data
 */
export function SaveComparyReview(data) {
  return request({
    url: "/base/comparyReview/saveComparyReview",
    method: "post",
    data
  });
}
/**
 * 企业注册审核
 * @param {*} data
 */
export function SaveCertificationReview(data) {
  return request({
    url: "/base/comparyReview/saveCertificationReview",
    method: "post",
    data
  });
}

/**
 * 通过主键获取单个企业信息
 * @param {*} data
 */
export function FindBaseComparyInfoById(data) {
  return request({
    url: "/base/comparyReview/findBaseComparyInfoById",
    method: "post",
    data
  });
}

/**
 * 企业认证申请
 * @param {*} data
 */
export function SaveCertificationCompary(data) {
  return request({
    url: "/base/compary/saveCertificationCompary",
    method: "post",
    data
  });
}






